import * as styles from "@bokio/designsystem/components/Form/form.scss";
import { mergeClassNames } from "@bokio/utils/classes";

import type { FC, PropsWithChildren } from "react";

type FieldProps = {
	className?: string;
	testId?: string;
};

const Field: FC<PropsWithChildren<FieldProps>> = ({ children, className, testId }) => {
	return (
		<div className={mergeClassNames(styles.field, className)} data-testid={testId}>
			{children}
		</div>
	);
};

export default Field;
